import React from "react";
import { Tile, TileProps } from "./Tile";
import { v4 as uuidv4 } from 'uuid';

export interface TileGroupProps {
    TileGroups?: TileProps[];
}


const TileGroup: React.FC<TileGroupProps> = (props) => {
    return (
        <div className="tile-group">
            {props.TileGroups?.map((tile) => (                
                   
                        <Tile
                            Color={tile.Color}                           
                            key={uuidv4()}
                            Title={tile.Title}
                            Total={tile.Total}
                        />                                    
            ))}
        </div>
    );
};

export default TileGroup;